<busy-indicator *ngIf="!isLoaded" big="true"></busy-indicator>

<ng-container *ngIf="isLoaded">
    <div *ngIf="!hasEmails">No Emails to Send</div>

    <div *ngIf="hasEmails" [formGroup]="formGroup" fxLayout="column" fxLayoutAlign="stretch start">
        <h3>Send PO Notice Emails</h3>

        <lgd-text fxFlexFill controlName="subject" label="Email Subject">
        </lgd-text>

        <lgd-textarea fxFlexFill controlName="message" label="Email Message">
        </lgd-textarea>

        <div fxFlexFill class="mt20 bold">Email Recipients</div>

        <div *ngIf="!isLoading" fxFlexFill class="mt5 scrollable-pane">
            <mat-list fxFlex>
                <ng-container *ngFor="let req of emails; even as isEven; last as isLast">

                    <mat-list-item *ngIf="req.Emails.length > 0" fxLayout="row" fxLayoutAlign="start center" [ngClass]="getEmailGroupClass(isEven)">

                        <div class="mt10">
                            <span class="bold">{{ req.Number }} - {{ req.Description }}</span>

                            <ul>
                                <li *ngFor="let email of req.Emails">
                                    <span *ngIf="email.IsVendorEmail" fxFlex="50">{{ req.Vendor }}: </span>
                                    <span *ngIf="!email.IsVendorEmail" fxFlex="50">Not a Vendor: </span>
                                    <span fxFlex="50" class="bold">{{ email.EmailAddress }}</span>
                                </li>
                            </ul>

                            <mat-divider *ngIf="!isLast"></mat-divider>
                        </div>
                    </mat-list-item>
                </ng-container>
            </mat-list>
        </div>

        <lgd-checkbox fxFlex="10" controlName="sendEmails" label="Send Emails">
        </lgd-checkbox>
    </div>
</ng-container>